import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthProvider from './contexts/AuthProvider';
import { TicketsProvider } from './contexts/TicketsProvider';
import PrivateRoute from './components/PrivateRoute';
import AppShell from './components/AppShell';
import Login from './pages/Login';
import SSOCallback from './pages/SSOCallback';
import BoardPage from './pages/BoardPage';
import PlanningPage from './pages/PlanningPage';
import TicketsPage from './pages/TicketsPage';
import TicketDetail from './pages/TicketDetail';
import AnalyticsPage from './pages/AnalyticsPage';
import IntegrationsPage from './pages/IntegrationsPage';
import TeamPage from './pages/TeamPage';
import SubmitTicket from './pages/SubmitTicket';
import { DEV_NO_AUTH } from './lib/devMode';

function App() {
  // Apply saved theme on app load (before any page renders).
  // Default to the dark terminal theme unless the user explicitly chose light.
  useEffect(() => {
    if (localStorage.getItem('theme') === 'light') {
      document.documentElement.classList.remove('dark');
    } else {
      document.documentElement.classList.add('dark');
    }
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public, login-free request form — shareable with anyone. */}
          <Route path="/submit" element={<SubmitTicket />} />

          {/* Auth routes are unused in dev mode (no Clerk), so redirect them. */}
          <Route path="/login" element={DEV_NO_AUTH ? <Navigate to="/board" replace /> : <Login />} />
          <Route path="/sso-callback" element={DEV_NO_AUTH ? <Navigate to="/board" replace /> : <SSOCallback />} />

          {/* Authenticated app shell with nested views. */}
          <Route
            element={
              <PrivateRoute>
                <TicketsProvider>
                  <AppShell />
                </TicketsProvider>
              </PrivateRoute>
            }
          >
            <Route path="/board" element={<BoardPage />} />
            <Route path="/planning" element={<PlanningPage />} />
            <Route path="/tickets" element={<TicketsPage />} />
            <Route path="/tickets/:id" element={<TicketDetail />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/team" element={<TeamPage />} />
          </Route>

          <Route path="/" element={<Navigate to="/board" replace />} />
          <Route path="*" element={<Navigate to="/board" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
